/**
 * UUID v4 with the same fallback chain as `@feedbacker/mcp-server` —
 * `crypto.randomUUID` → `crypto.getRandomValues` → `Math.random`.
 */
const getCrypto = () => {
    const g = globalThis;
    return g.crypto ?? null;
};
const formatUuid = (bytes) => {
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
    const hex = [];
    for (let i = 0; i < 16; i += 1) {
        hex.push((bytes[i] ?? 0).toString(16).padStart(2, "0"));
    }
    return (hex.slice(0, 4).join("") +
        "-" +
        hex.slice(4, 6).join("") +
        "-" +
        hex.slice(6, 8).join("") +
        "-" +
        hex.slice(8, 10).join("") +
        "-" +
        hex.slice(10, 16).join(""));
};
export const uuid = () => {
    const c = getCrypto();
    if (c?.randomUUID)
        return c.randomUUID();
    const bytes = new Uint8Array(16);
    if (c?.getRandomValues) {
        c.getRandomValues(bytes);
    }
    else {
        for (let i = 0; i < 16; i += 1) {
            bytes[i] = Math.floor(Math.random() * 256);
        }
    }
    return formatUuid(bytes);
};
//# sourceMappingURL=id.js.map